export const MenuSeperator = () => {
  return <div className="border-[1px] border-blue-100 opacity-30" />;
};
